export const ZKDevelopmentProcessData = {
  mainText: `Our ZK Development Process`,
  description: `Our development approach combines rigorous cryptographic engineering with practical business requirements, ensuring each ZK system is both mathematically secure and operationally viable. We maintain transparent communication throughout the process, providing regular updates and working prototypes so you can see progress and provide feedback at every stage.`,
  services: [
    {
      step: '1',
      title: 'Discovery & Architecture',
      description:
        'We dive deep into your requirements and design a ZK system that actually makes sense for your business goals. No cookie-cutter solutions.',
      stepColor: 'teal',
    },
    {
      step: '2',
      title: 'Proof-of-Concept',
      description:
        'We build a working prototype to validate the approach. You see results early, we catch issues before they become expensive.',
      stepColor: 'teal',
    },
    {
      step: '3',
      title: 'Full Implementation',
      description:
        'Production-quality code with proper testing, documentation, and security considerations. We optimize for performance from day one.',
      stepColor: 'teal',
    },
    {
      step: '4',
      title: 'Testing & Audit',
      description:
        'Comprehensive testing, including security audits. ZK systems are only as strong as their weakest link.',
      stepColor: 'teal',
    },
    {
      step: '5',
      title: 'Deployment & Support',
      description:
        'We handle deployment and provide ongoing support. Your success is our success.',
      stepColor: 'teal',
    },
  ],
};
